import genresSource from "./genres.json";
import photographerGenreAssignmentsSource from "./photographerGenreAssignments.json";

export const photographerGenreAssignments =
  photographerGenreAssignmentsSource.assignments || [];

const photographerAssignmentsByGenre = photographerGenreAssignments.reduce(
  (grouped, assignment) => {
    if (!grouped[assignment.genre_id]) {
      grouped[assignment.genre_id] = [];
    }

    grouped[assignment.genre_id].push(assignment);
    return grouped;
  },
  {}
);

Object.values(photographerAssignmentsByGenre).forEach((assignments) => {
  assignments.sort(
    (first, second) =>
      Number(second.is_primary) - Number(first.is_primary) ||
      first.photographer_id - second.photographer_id
  );
});

// Compatibility layer: keep existing named exports while using JSON as source of truth.
export const genresData = (genresSource.genres || []).map((genre) => ({
  ...genre,
  subgenres: (genre.subgenres || []).map((subgenre) => {
    const photographerAssignments =
      photographerAssignmentsByGenre[subgenre.id] || [];

    return {
      ...subgenre,
      // Replace the legacy placeholder IDs with the Supabase assignment snapshot.
      photographers: photographerAssignments.map(
        (assignment) => assignment.photographer_id
      ),
      photographerAssignments,
    };
  }),
}));

export const genreTimelineData = Object.fromEntries(
  Object.entries(genresSource.genreTimelineData || {}).map(([timelineId, events]) => [
    timelineId,
    (events || []).map((event) => ({
      year: event.year,
      event: event.event,
    })),
  ])
);

// Optional zh timeline export for future CN toggle usage.
export const genreTimelineDataZh = Object.fromEntries(
  Object.entries(genresSource.genreTimelineData || {}).map(([timelineId, events]) => [
    timelineId,
    (events || []).map((event) => ({
      year: event.year,
      event: event.event_zh || event.event,
    })),
  ])
);

export default genresSource;
